import { postHogCapture } from 'components/analytics/PostHog';
import isBrowser from 'util/isBrowser';
import apiCall, { BASE_URL, headers } from './client';
import { postHogReset } from 'lib/posthog';

function parseJwt(token) {
  if (!token) {
    return {};
  }
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    return {};
  }
}

function setTokens(response) {
  localStorage.setItem('access_token', response.headers.get('Access-Token'));
  localStorage.setItem('refresh_token', response.headers.get('Refresh-Token'));
  const current_employer_profile_id = response.headers.get('Current-Employer-Profile-Id');

  const localStorageEmployerProfileId = localStorage.getItem('current_employer_profile_id');
  const employerProfileCount = localStorage.getItem('employerProfilesCount');

  if (
    !localStorageEmployerProfileId &&
    window.location.pathname !== '/select-employer-profile' &&
    employerProfileCount > 1
  ) {
    return (window.location.href = '/select-employer-profile');
  } else if (
    current_employer_profile_id &&
    !!current_employer_profile_id &&
    !!employerProfileCount
  ) {
    localStorage.setItem('current_employer_profile_id', current_employer_profile_id);
  }
}

const eventCapture = postHogCapture();
const eventCaptureUndeb = postHogCapture(false);

export async function updateAccount(data) {
  const body = {
    data: {
      attributes: { ...data },
    },
  };
  return await apiCall(`account`, 'PUT', { body: JSON.stringify(body) });
}

export function isImpersonated() {
  if (isBrowser()) {
    const access_token = localStorage.getItem('access_token');
    const data = parseJwt(access_token);
    return Boolean(data.impersonated);
  }
  return false;
}

export function deleteTokens(response) {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('current_employer_profile_id');
  localStorage.removeItem('employerProfilesCount');
  localStorage.removeItem('userType');
}

export function tokensExist() {
  if (isBrowser()) {
    const access_token = localStorage.getItem('access_token');
    const refresh_token = localStorage.getItem('refresh_token');
    const exists = !!access_token && !!refresh_token;
    const isNull = access_token === 'null' || refresh_token === 'null';

    return exists && !isNull;
  }
  return false;
}

export async function refreshTokens(params) {
  const response = await fetch(`${BASE_URL}/accounts/tokens`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: headers(),
  });
  setTokens(response);
  const data = await response.json();
  return data;
}

export async function signIn(params) {
  const response = await fetch(`${BASE_URL}/accounts/sign_in`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  setTokens(response);
  const data = await response.json();
  if (data.status == 'error') {
    throw data.error;
  } else {
    eventCapture('Login');
  }
  return data;
}

export async function resetPasswordForEmail(email) {
  const response = await fetch(`${BASE_URL}/account/reset_password`, {
    method: 'POST',
    body: JSON.stringify({ email }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  setTokens(response);
  const data = await response.json();
  return data;
}

export async function resetPasswordWithTokenParam(params) {
  const response = await fetch(`${BASE_URL}/account/reset_password`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  setTokens(response);
  const data = await response.json();
  return data;
}

export async function signUp(params) {
  return fetch(`${BASE_URL}/accounts/sign_up`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      setTokens(response);
      return response.body;
    })
    .then((body) => {
      return body.getReader().read();
    })
    .then(({ done, value }) => {
      const data = JSON.parse(new TextDecoder('utf-8').decode(value));
      return data;
    })
    .catch((error) => {
      throw error;
    });
}

export function signOut(redirectUrl = '/login') {
  fetch(`${BASE_URL}/accounts/sign_out`, {
    method: 'DELETE',
    headers: headers(),
  });

  deleteTokens();
  eventCaptureUndeb('Logout');
  postHogReset();

  if (redirectUrl) {
    return (window.location.href = redirectUrl);
  }
}
